module.exports = __webpack_public_path__ + "static/media/loc3_img31.b2fb1bb3.jpg";